<template>
  <BaseAutoCompleteWithSingleSelectedItem
    v-model="modelValue"
    label="運営会社"
    itemName="name"
    :items="items"
    :initial-item-id="props.initialOperationId"
    :management-office="props.managementOffice"
    :errorMessages="props.errorMessages"
    selectFirstIfOnlyOne
    :clearable="props.clearable"
    :readonly="props.readonly"
    :disabled="props.disabled"
  />
</template>
<script setup lang="ts">
import BaseAutoCompleteWithSingleSelectedItem from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import getManagementOffice from '@/types/responses/getManagementOffice';
import getOperationOffice from '@/types/responses/getOperationOffice';
import { onMounted, ref, computed, withDefaults, watch } from 'vue';
import Api from '@/services/api/ApiServiceFabrick';

const props = withDefaults(
  defineProps<{
  modelValue: getOperationOffice | undefined | null;
  managementOffice?: getManagementOffice;
  errorMessages?: string[];
  selectFirstIfOnlyOne?: boolean;
  initialOperationId?: number;
  clearable: boolean;
  readonly?: boolean;
  disabled?: boolean;
  filterParams?: {
    [key: string]: string[]
  }
}>(),
{
  clearable: true,
  readonly: false,
  disabled: false,
})

const emit = defineEmits(['update:modelValue']);

const items = ref<getOperationOffice[]>([]);

onMounted(() => {
  Api()
    .autoCompleteOperationOffices()
    .then((data) => {
      setItems(data);
      setModelValue();
    });
});

watch(
  () => props.initialOperationId,
  () => {
    setModelValue();
  }
);

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

const setModelValue = () => {
  let filteredItems = items.value;
  if (props.initialOperationId) {
    modelValue.value = filteredItems.filter((item) => {
      return item.id === props.initialOperationId
    })[0];
  }
}

function setItems(operationOffices: getOperationOffice[]) {
  if (!props.filterParams) {
    return items.value = operationOffices;
  }

  let filteredItems: getOperationOffice[] = [];
  if (Object.keys(props.filterParams).indexOf('tenko_type') !== -1) {
    operationOffices.forEach((operationOffice: getOperationOffice) => {
      if (operationOffice.tenko_type && props.filterParams?.tenko_type.includes(operationOffice.tenko_type)) {
        filteredItems.push(operationOffice);
      }
    })
  }

  items.value = filteredItems;
}
</script>
